var _rect, _text, _text2, _rect2, _text3, _rect3, _path, _g, _rect4, _rect5, _g2, _g3, _g4, _circle, _rect6, _rect7, _text4, _rect8, _circle2, _path2, _text5, _rect9, _g5, _g6, _rect0, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDashboard = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1000 570",
  width: 1000,
  height: 570,
  role: "img",
  "aria-label": "Dashboard screen",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 1000,
  height: 570,
  rx: 14,
  fill: "#F6F8FE"
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  x: 24,
  y: 38,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 24,
  fontWeight: 700,
  fill: "#172033"
}, "Dashboard")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
  x: 24,
  y: 59,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 11,
  fill: "#66728A"
}, "Last updated: Jun 11, 2026, 4:23 PM UTC")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 906,
  y: 21,
  width: 72,
  height: 25,
  rx: 5,
  fill: "#FFFFFF",
  stroke: "#D7DEE9"
})), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
  x: 938,
  y: 37,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fontWeight: 700,
  fill: "#334155",
  textAnchor: "middle"
}, "Last 7 days")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 970,
  y: 27,
  width: 8,
  height: 8,
  rx: 1,
  fill: "none",
  stroke: "#334155"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M972 25v5M976 25v5",
  stroke: "#334155",
  strokeWidth: 1
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fontFamily: "Inter, DM Sans, Arial, sans-serif"
}, /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 72,
  width: 239,
  height: 70,
  rx: 8,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 279,
  y: 72,
  width: 239,
  height: 70,
  rx: 8,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 535,
  y: 72,
  width: 239,
  height: 70,
  rx: 8,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 789,
  y: 72,
  width: 189,
  height: 70,
  rx: 8,
  fill: "#F8FFFB",
  stroke: "#DAF3E4"
}), /*#__PURE__*/React.createElement("text", {
  x: 39,
  y: 95,
  fontSize: 10,
  fill: "#66728A"
}, "Total API Calls"), /*#__PURE__*/React.createElement("text", {
  x: 39,
  y: 124,
  fontSize: 24,
  fontWeight: 700,
  fill: "#172033"
}, "1"), /*#__PURE__*/React.createElement("text", {
  x: 294,
  y: 95,
  fontSize: 10,
  fill: "#66728A"
}, "Usage"), /*#__PURE__*/React.createElement("text", {
  x: 294,
  y: 124,
  fontSize: 24,
  fontWeight: 700,
  fill: "#172033"
}, "2"), /*#__PURE__*/React.createElement("text", {
  x: 550,
  y: 95,
  fontSize: 10,
  fill: "#66728A"
}, "Failed"), /*#__PURE__*/React.createElement("text", {
  x: 550,
  y: 124,
  fontSize: 24,
  fontWeight: 700,
  fill: "#172033"
}, "0"), /*#__PURE__*/React.createElement("text", {
  x: 804,
  y: 95,
  fontSize: 10,
  fill: "#66728A"
}, "Insufficient Data Responses"), /*#__PURE__*/React.createElement("circle", {
  cx: 814,
  cy: 118,
  r: 8,
  fill: "none",
  stroke: "#46B878",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M810 118l3 3 6-7",
  stroke: "#46B878",
  strokeWidth: 1.5,
  fill: "none",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("text", {
  x: 832,
  y: 124,
  fontSize: 22,
  fontWeight: 700,
  fill: "#2D8A56"
}, "0"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 154,
  width: 494,
  height: 266,
  rx: 8,
  fill: "#FFFFFF"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 535,
  y: 154,
  width: 443,
  height: 266,
  rx: 8,
  fill: "#FFFFFF"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fontFamily: "Inter, DM Sans, Arial, sans-serif"
}, /*#__PURE__*/React.createElement("text", {
  x: 39,
  y: 181,
  fontSize: 12,
  fontWeight: 500,
  fill: "#172033"
}, "Error rate over time"), /*#__PURE__*/React.createElement("text", {
  x: 39,
  y: 211,
  fontSize: 21,
  fontWeight: 700,
  fill: "#172033"
}, "0.0%"), /*#__PURE__*/React.createElement("text", {
  x: 39,
  y: 229,
  fontSize: 9,
  fill: "#66728A"
}, "Average Error Rate"), /*#__PURE__*/React.createElement("text", {
  x: 550,
  y: 181,
  fontSize: 12,
  fontWeight: 500,
  fill: "#172033"
}, "API call volume"), /*#__PURE__*/React.createElement("circle", {
  cx: 553,
  cy: 195,
  r: 3,
  fill: "#2F6DF6"
}), /*#__PURE__*/React.createElement("text", {
  x: 562,
  y: 198,
  fontSize: 8,
  fill: "#66728A"
}, "Failed"), /*#__PURE__*/React.createElement("circle", {
  cx: 592,
  cy: 195,
  r: 3,
  fill: "#BFDBFE"
}), /*#__PURE__*/React.createElement("text", {
  x: 601,
  y: 198,
  fontSize: 8,
  fill: "#66728A"
}, "Success"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  stroke: "#E5EAF2",
  strokeDasharray: "2 3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64 253H503"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64 286H503"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64 319H503"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64 352H503"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64 386H503"
}), /*#__PURE__*/React.createElement("path", {
  d: "M575 222H962"
}), /*#__PURE__*/React.createElement("path", {
  d: "M575 263H962"
}), /*#__PURE__*/React.createElement("path", {
  d: "M575 304H962"
}), /*#__PURE__*/React.createElement("path", {
  d: "M575 345H962"
}), /*#__PURE__*/React.createElement("path", {
  d: "M575 386H962"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 7,
  fill: "#66728A"
}, /*#__PURE__*/React.createElement("text", {
  x: 42,
  y: 256
}, "100%"), /*#__PURE__*/React.createElement("text", {
  x: 45,
  y: 289
}, "75%"), /*#__PURE__*/React.createElement("text", {
  x: 45,
  y: 322
}, "50%"), /*#__PURE__*/React.createElement("text", {
  x: 45,
  y: 355
}, "25%"), /*#__PURE__*/React.createElement("text", {
  x: 49,
  y: 389
}, "0%"), /*#__PURE__*/React.createElement("text", {
  x: 568,
  y: 225
}, "1"), /*#__PURE__*/React.createElement("text", {
  x: 561,
  y: 266
}, "0.75"), /*#__PURE__*/React.createElement("text", {
  x: 564,
  y: 307
}, "0.5"), /*#__PURE__*/React.createElement("text", {
  x: 561,
  y: 348
}, "0.25"), /*#__PURE__*/React.createElement("text", {
  x: 568,
  y: 389
}, "0"), /*#__PURE__*/React.createElement("text", {
  x: 279,
  y: 402
}, "Jun 8"), /*#__PURE__*/React.createElement("text", {
  x: 791,
  y: 402
}, "Jun 8"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 284,
  cy: 386,
  r: 2.5,
  fill: "#2F6DF6"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 783,
  y: 222,
  width: 18,
  height: 164,
  rx: 3,
  fill: "#BFDBFE"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 436,
  width: 954,
  height: 128,
  fill: "#FFFFFF"
})), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
  x: 50,
  y: 478,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 13,
  fontWeight: 700,
  fill: "#172033"
}, "Active API Keys")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 858,
  y: 461,
  width: 104,
  height: 28,
  rx: 5,
  fill: "#2F6DF6"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 872,
  cy: 475,
  r: 5,
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 1.2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M872 472v6M869 475h6",
  stroke: "#FFFFFF",
  strokeWidth: 1.2
})), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
  x: 918,
  y: 479,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 9,
  fontWeight: 700,
  fill: "#FFFFFF",
  textAnchor: "middle"
}, "Create API Key")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 39,
  y: 515,
  width: 946,
  height: 30,
  rx: 4,
  fill: "#FAFBFC"
})), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 7,
  fontWeight: 700,
  fill: "#334155"
}, /*#__PURE__*/React.createElement("text", {
  x: 52,
  y: 534
}, "Label"), /*#__PURE__*/React.createElement("text", {
  x: 175,
  y: 534
}, "Key"), /*#__PURE__*/React.createElement("text", {
  x: 275,
  y: 534
}, "Client Id"), /*#__PURE__*/React.createElement("text", {
  x: 403,
  y: 534
}, "Usage"), /*#__PURE__*/React.createElement("text", {
  x: 520,
  y: 534
}, "Credits"), /*#__PURE__*/React.createElement("text", {
  x: 652,
  y: 534
}, "Created On"), /*#__PURE__*/React.createElement("text", {
  x: 777,
  y: 534
}, "Last Used"), /*#__PURE__*/React.createElement("text", {
  x: 900,
  y: 534
}, "Status"), /*#__PURE__*/React.createElement("text", {
  x: 953,
  y: 534
}, "Actions"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 8,
  fill: "#334155"
}, /*#__PURE__*/React.createElement("text", {
  x: 52,
  y: 556
}, "Default key"), /*#__PURE__*/React.createElement("text", {
  x: 175,
  y: 556
}, "1d************"), /*#__PURE__*/React.createElement("text", {
  x: 275,
  y: 556
}, "qa-test-company"), /*#__PURE__*/React.createElement("text", {
  x: 403,
  y: 556,
  fontWeight: 700
}, "2"), /*#__PURE__*/React.createElement("text", {
  x: 416,
  y: 556
}, "calls"), /*#__PURE__*/React.createElement("text", {
  x: 520,
  y: 556,
  fontWeight: 700
}, "6"), /*#__PURE__*/React.createElement("text", {
  x: 532,
  y: 556,
  fill: "#66728A"
}, "/ 16"), /*#__PURE__*/React.createElement("text", {
  x: 652,
  y: 556
}, "06/02/2026"), /*#__PURE__*/React.createElement("text", {
  x: 777,
  y: 556
}, "06/09/2026"), /*#__PURE__*/React.createElement("circle", {
  cx: 904,
  cy: 553,
  r: 2,
  fill: "#2E8B57"
}), /*#__PURE__*/React.createElement("text", {
  x: 912,
  y: 556,
  fill: "#2E8B57"
}, "Active"))), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: 951,
  y: 544,
  width: 20,
  height: 20,
  rx: 5,
  fill: "#FFFFFF",
  stroke: "#E1E7F0"
})), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  fill: "#64748B"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 961,
  cy: 550,
  r: 1.2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 961,
  cy: 554,
  r: 1.2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 961,
  cy: 558,
  r: 1.2
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDashboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dashboard.fefefa974ee907cd7472b8549ef5835c.svg";